import React from 'react';
import Spinner from '../../atoms/Spinner';

const StatusPageSpinner = ({title, subTitle}) => (
    <div className="status-page-spinner">
        <h1 className="status-page-title">
            {title}
        </h1>
        <Spinner />
        <h2 className="status-page-subtitle">
            {subTitle}
        </h2>
    </div>
);

export default StatusPageSpinner;
